module.exports = __webpack_public_path__ + "static/media/Poppins-BoldItalic-devanagari.17352fe0.woff2";